export function initLanguageSwitcher(root) {
	const toggle = root.querySelector('.lang-switcher__toggle');
	const list = root.querySelector('.lang-switcher__list');
	if (!toggle || !list) {
		return;
	}

	const links = () => [...list.querySelectorAll('a')];
	const isOpen = () => toggle.getAttribute('aria-expanded') === 'true';

	const setOpen = (open) => {
		toggle.setAttribute('aria-expanded', String(open));
		list.hidden = !open;
		root.classList.toggle('is-open', open);
	};

	const close = (returnFocus = false) => {
		if (!isOpen()) {
			return;
		}
		setOpen(false);
		if (returnFocus) {
			toggle.focus();
		}
	};

	const focusLink = (offset) => {
		const items = links();
		const index = items.indexOf(document.activeElement);
		const next = index === -1 ? (offset > 0 ? 0 : items.length - 1) : (index + offset + items.length) % items.length;
		items[next]?.focus();
	};

	// Hidden from JS so the list stays reachable when scripts fail.
	setOpen(false);

	toggle.addEventListener('click', () => setOpen(!isOpen()));

	root.addEventListener('keydown', (event) => {
		switch (event.key) {
			case 'Escape':
				if (isOpen()) {
					event.preventDefault();
					close(true);
				}
				break;
			case 'ArrowDown':
			case 'ArrowUp':
				event.preventDefault();
				if (!isOpen()) {
					setOpen(true);
				}
				focusLink(event.key === 'ArrowDown' ? 1 : -1);
				break;
			case 'Home':
			case 'End':
				if (isOpen() && list.contains(document.activeElement)) {
					event.preventDefault();
					const items = links();
					items[event.key === 'Home' ? 0 : items.length - 1]?.focus();
				}
				break;
		}
	});

	root.addEventListener('focusout', (event) => {
		if (!root.contains(event.relatedTarget)) {
			close();
		}
	});

	document.addEventListener('click', (event) => {
		if (!root.contains(event.target)) {
			close();
		}
	});
}
